import { newTracker, setUserId, trackPageView } from '@snowplow/browser-tracker';
import { TimezonePlugin } from '@snowplow/browser-plugin-timezone';
import {
  LinkClickTrackingPlugin,
  refreshLinkClickTracking,
  enableLinkClickTracking,
} from '@snowplow/browser-plugin-link-click-tracking';
import { getAccessToken, getSubId } from '@devhacker/shared/features/auth/utils/token';
import { useUserStore } from '~/features/user/store';

// Конфиг общий с lh-front: тот же коллектор и appId, сайты различаются по url событий
export default defineNuxtPlugin({
  name: 'snowplow',
  dependsOn: ['pinia'],
  setup() {
    // остальные опции совпадают с дефолтами @snowplow/browser-tracker v3
    newTracker('sp1', 'a.lifehacker.ru/lifehacker/', {
      appId: 'lh-snowplow',
      cookieSameSite: 'Lax',
      encodeBase64: false,
      maxPostBytes: 50_000,
      maxLocalStorageQueueSize: 2000,
      connectionTimeout: 3500,
      contexts: {
        webPage: true,
        session: true,
      },
      postPath: 'tracker',
      plugins: [LinkClickTrackingPlugin(), TimezonePlugin()],
    });

    // ! user_id
    // * subId из токена равен integer_id пользователя; берём его сразу, чтобы первый pageview ушёл с uid,
    // * не дожидаясь асинхронной загрузки профиля в user.plugin.client.ts
    const accessToken = getAccessToken();
    setUserId((accessToken && getSubId(accessToken)) || null);

    const userStore = useUserStore();
    watch(
      () => userStore.userData?.integer_id,
      (userId) => setUserId(userId ? String(userId) : null),
    );

    trackPageView();

    // ! clicks
    enableLinkClickTracking({ pseudoClicks: true, trackContent: true });
    // * snowplow v3 навешивает обработчики только на ссылки, которые есть в DOM в момент вызова,
    // * поэтому ссылки подгружаемых позже блоков перенавешиваем раз в секунду
    setInterval(() => {
      refreshLinkClickTracking();
    }, 1000);
  },
});
